<template>
  <div class="container">
    <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >监控告警</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/monitor/equipment/equipment-monitor' }">设备监控</el-breadcrumb-item>
          <el-breadcrumb-item >故障处理</el-breadcrumb-item>
          <el-breadcrumb-item >添加处理信息</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="content">
      <dv-border-box-12 >
        <div class="handle">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">添加处理信息</div>
            </div>
          </div>
          <div class="handle-message">
            <el-form :model="form" :rules="rules" ref="form" label-width="140px" class="demo-form">
              <el-form-item label="维护内容" prop="process" style="margin-top: 20px;">
                <el-input type="textarea" id="process"  v-model="form.process" :autosize="{ minRows: 4, maxRows: 8}" style="width: 50%;font-size: 15px;"></el-input>
              </el-form-item>
              <el-form-item label="维护结束时间" prop="finishTime" class="time" style="margin-top: 50px;width: 54%;">
                <el-col :span="12">
                  <el-date-picker
                  type="datetime"
                  placeholder="选择具体时间"
                  id="finishTime"
                  v-model="form.finishTime"
                  style="width: 100%;"
                  :picker-options="forbiddenTime"
                  format="yyyy-MM-dd HH:mm"
                  value-form="yyyy-MM-dd HH:mm"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item label="维护时长(分钟)" prop="duration" style="margin-top: 30px;">
                <el-input
                  type="text"
                  id="duration"
                  v-model="form.duration"
                  style="width: 50%;font-size: 15px;"
                  oninput="value=value.replace(/[^\d]/g,'')"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="submitForm('form')" class="action-button" >立即保存</el-button>
                <el-button @click="resetForm('form')" class="action-button" style="margin-left: 60px;">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </dv-border-box-12>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id:'',
        mId:'',
        form: {
          process:'',//维修内容
          duration:'',//处理时长
          finishTime:'',//维修结束时间
        },

        rules: {
          process: [{ required: true, message: '请填写维护内容', trigger: 'blur' }],
          finishTime: [{required: true, message: '请选择维护结束时间', trigger: 'change' }],
          duration: [{ required: true, message: '请填写时长', trigger: 'blur' }]
        },

        forbiddenTime:{
          disabledDate(time){
            return time.getTime() > Date.now();
          }
        }
      }
    },
    methods: {
      goBack() {
        this.$router.back()
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.toAddHandleMessage()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      toAddHandleMessage(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/equipment/maintenance-finish'

        var date = new Date(this.form.finishTime)
        var year = date.getFullYear()
        var month = date.getMonth()+1
        var day = date.getDate()
        var hour = date.getHours()
        var minite = date.getMinutes()
        var finishTime = this.judgeNumber(year)+'-'+this.judgeNumber(month)+'-'+this.judgeNumber(day)+' '+this.judgeNumber(hour)+':'+this.judgeNumber(minite)

        const data = {
          'eId':this.id,
          'mId':this.mId,
          'process':this.form.process,
          'finishTime':finishTime,
          'duration':this.form.duration
        }

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message('提交成功');
              this.resetForm('form');
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      judgeNumber(n){
        if(n<10){
          return '0'+n;
        }

        return n;
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    },
    created() {
      this.id = this.$route.query.id;
      this.mId =  this.$route.query.mid;
    }
  }
</script>


<style lang="scss" scoped>
  .container{
    height: 100%;
    margin-top: $header-height;

    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }


    .content{
      width: 100%;
      // height: 540px;
      padding: 0;
      margin: 0;
    }

    .handle{
      border-radius: 12px;
      margin: 16px 0px 0px 6px;
      padding-top: 6px;

      .handle-message{
        padding-top: 25px;
        padding-bottom: 30px;

        .action-button{
          width: 120px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
        }
      }

      .el-form-item__error{
        margin-top: 4px;
      }
      //表单验证错误提示偏移
      .time .el-form-item__error{
        margin-top: -14px;
      }
    }

    // 公共头部样式
    .header-common{
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 6px;

      .header-common-left{

        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
      }
    }

  }


</style>



// WEBPACK FOOTER //
// src/view/monitor/equipment/equipment-monitor-detail-handle.vue